import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.svg'
import _imports_1 from '../assets/Google-icon-btn.svg'


const _hoisted_1 = { class: "lg:mt-20 sm:mt-20 sm:max-h-screen flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer sm:mx-auto sm:w-full sm:max-w-md" }, [
  /*#__PURE__*/_createElementVNode("img", {
    href: "/home",
    class: "cursor-pointer mx-auto h-10 w-auto",
    src: _imports_0,
    alt: "Your Company"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900" }, "Sign in to your account")
], -1)
const _hoisted_3 = { class: "mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]" }
const _hoisted_4 = { class: "bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6\"><div class=\"sm:col-span-3\"><label for=\"first-name\" class=\"block text-sm font-medium leading-6 text-gray-900\">First name</label><div class=\"mt-2\"><input type=\"text\" name=\"first-name\" id=\"first-name\" autocomplete=\"given-name\" class=\"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6\"></div></div><div class=\"sm:col-span-3\"><label for=\"last-name\" class=\"block text-sm font-medium leading-6 text-gray-900\">Last name</label><div class=\"mt-2\"><input type=\"text\" name=\"last-name\" id=\"last-name\" autocomplete=\"family-name\" class=\"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6\"></div></div></div>", 1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Email address", -1)
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Password", -1)
const _hoisted_9 = { class: "mt-2 relative" }
const _hoisted_10 = ["type"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-gray-900"
}, "Re-Password", -1)
const _hoisted_12 = { class: "mt-2 relative" }
const _hoisted_13 = ["type"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
  }, "Sign Up")
], -1)
const _hoisted_15 = {
  "mx-auto": "",
  flex: "",
  "justify-center": "",
  "items-center": ""
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"relative mt-10\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-gray-200\"></div></div><div class=\"relative flex justify-center text-sm font-medium leading-6\"><span class=\"bg-white px-6 text-gray-900\">Or Login with</span></div></div>", 1)
const _hoisted_17 = { class: "mx-auto mt-6 items-center justify-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-6"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold leading-6" }, "Google", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mt-10 text-center text-sm text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" Already have an Account? " + /*#__PURE__*/_toDisplayString(' ') + " "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
  }, "Login")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroIconEye = _resolveComponent("HeroIconEye")!
  const _component_HeroIconEyeOff = _resolveComponent("HeroIconEyeOff")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "space-y-6",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.signUp && $setup.signUp(...args)), ["prevent"]))
        }, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                name: "email",
                type: "email",
                autocomplete: "email",
                required: "",
                class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
              }, null, 512), [
                [_vModelText, $setup.email]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.showPassword ? 'text' : 'password',
                id: "password",
                name: "password",
                autocomplete: "current-password",
                required: "",
                class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
              }, null, 8, _hoisted_10), [
                [_vModelDynamic, $setup.password]
              ]),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPassword = !$setup.showPassword)),
                class: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
              }, [
                ($setup.showPassword)
                  ? (_openBlock(), _createBlock(_component_HeroIconEye, {
                      key: 0,
                      class: "h-6 w-6 color-black"
                    }))
                  : (_openBlock(), _createBlock(_component_HeroIconEyeOff, {
                      key: 1,
                      class: "h-6 w-6 color-black"
                    }))
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.showRePassword ? 'text' : 'password',
                id: "re-password",
                name: "re-password",
                autocomplete: "current-password",
                required: "",
                class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.rePassword) = $event))
              }, null, 8, _hoisted_13), [
                [_vModelDynamic, $setup.rePassword]
              ]),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showRePassword = !$setup.showRePassword)),
                class: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
              }, [
                ($setup.showRePassword)
                  ? (_openBlock(), _createBlock(_component_HeroIconEye, {
                      key: 0,
                      class: "h-6 w-6"
                    }))
                  : (_openBlock(), _createBlock(_component_HeroIconEyeOff, {
                      key: 1,
                      class: "h-6 w-6"
                    }))
              ])
            ])
          ]),
          _hoisted_14
        ], 32),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.signInWithGoogle && $setup.signInWithGoogle(...args))),
              href: "#",
              class: "flex w-full items-center justify-center gap-3 rounded-md bg-[#1D9BF0] px-3 py-1.5 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1D9BF0]"
            }, _hoisted_20)
          ])
        ])
      ]),
      _hoisted_21
    ])
  ]))
}